import React from 'react';
import { Grid, GridItem, ISelectOption, SelectField, TextField } from '../../../components';
import { StatesLabelValue } from '../../../enums/states';

export interface IEditAddressDataEntryProps {
  isRequired?: boolean;
  readOnlyState?: boolean;
  name?: string;
  isCamelCase?: boolean;
}

export const EditAddressDataEntry: React.FC<IEditAddressDataEntryProps> = ({
  isRequired,
  readOnlyState,
  name,
  isCamelCase,
}) => {
  const namePrefix: string = name ? `${name}.` : '';
  const stateFilterOptions = (option: ISelectOption<string>, value: string) =>
    option.value.toLowerCase().indexOf((value || '').toLowerCase()) >= 0;

  const streetAddressName = isCamelCase ? 'streetAddress' : 'street_address';
  const stateName = isCamelCase ? 'stateAbbreviation' : 'state';
  const zipCodeName = isCamelCase ? 'zipCode' : 'zip_code';

  return (
    <Grid columnCount={3}>
      <GridItem columnStart={`span 2`}>
        <TextField
          name={`${namePrefix}${streetAddressName}`}
          data-test-id={`${namePrefix}street_address`}
          label={`Street Address`}
          isRequired={isRequired}
          placeholder={'123 Main Street'}
        />
      </GridItem>
      <TextField
        name={`${namePrefix}unit`}
        data-test-id={`${namePrefix}unit`}
        label={`Unit`}
        isRequired={false}
        placeholder={'Unit #'}
      />
      <TextField
        name={`${namePrefix}city`}
        data-test-id={`${namePrefix}city`}
        isRequired={isRequired}
        label={`City`}
        placeholder={'Small Town City'}
      />
      <SelectField
        isDisabled={readOnlyState}
        name={`${namePrefix}${stateName}`}
        data-test-id={`${namePrefix}state`}
        options={StatesLabelValue}
        filterOption={stateFilterOptions}
        label={`State`}
        isRequired={isRequired}
        placeholder={`Select one...`}
      />
      <TextField
        name={`${namePrefix}${zipCodeName}`}
        data-test-id={`${namePrefix}zip_code`}
        isRequired={isRequired}
        label={`Zip Code`}
        placeholder={`12345`}
      />
    </Grid>
  );
};
